/**
 * Activation Tour v1 — Config-driven step definitions.
 *
 * Rules:
 *   - Steps are plain data objects.
 *   - Adding a new step = adding an object to the array.
 *   - `isAvailable(ctx)` gates visibility.
 *   - `isComplete(ctx)` gates auto-advance.
 */

export const activationTour = {
  id: "activation",
  version: 1,
  steps: [
    {
      id: "add-parts",
      title: "Add Your Parts",
      body: "Start by adding the parts your crew uses every day. You only need 10 to get going.",
      route: "/catalogue",
      targetSelector: '[data-testid="nav-parts-list"]',
      fallbackSelector: '[data-testid="nav-inventory"]',
      ensureNavOpen: "inventory",
      ctaLabel: "Go to Parts List",
      ctaAction: "navigate",
      isAvailable: () => true,
      isComplete: (ctx) => ctx.parts_count > 0,
    },
    {
      id: "stock-warehouse",
      title: "Stock Your Warehouse",
      body: "Now add quantities to your warehouse so you know what's on the shelf.",
      route: "/warehouse",
      targetSelector: '[data-testid="nav-warehouses"]',
      fallbackSelector: '[data-testid="nav-inventory"]',
      ensureNavOpen: "inventory",
      ctaLabel: "Go to Warehouse",
      ctaAction: "navigate",
      isAvailable: (ctx) => ctx.parts_count > 0,
      isComplete: (ctx) => ctx.warehouse_has_stock === true,
    },
    {
      id: "add-vehicles",
      title: "Add Your Vehicles",
      body: "Create your first truck or service vehicle to start tracking mobile inventory.",
      route: "/vans",
      targetSelector: '[data-testid="nav-vehicles"]',
      fallbackSelector: '[data-testid="nav-fleet"]',
      ensureNavOpen: "fleet",
      ctaLabel: "Go to Vehicles",
      ctaAction: "navigate",
      isAvailable: (ctx) => ctx.parts_count > 0,
      isComplete: (ctx) => ctx.vehicles_count > 0,
    },
    {
      id: "invite-team",
      title: "Invite Your Team",
      body: "Add your techs so they can log usage, request parts, and check stock from their phone.",
      route: "/team",
      targetSelector: '[data-testid="nav-team"]',
      ctaLabel: "Go to Team",
      ctaAction: "navigate",
      isAvailable: (ctx) => ctx.vehicles_count > 0,
      isComplete: (ctx) => ctx.team_count > 1,
    },
    {
      id: "assign-stock",
      title: "Assign Parts to a Vehicle",
      body: "Open a vehicle and tap Add Stock to load it up. You can even create new parts inline.",
      route: "/vans",
      targetSelector: '[data-testid="nav-vehicles"]',
      fallbackSelector: '[data-testid="nav-fleet"]',
      ensureNavOpen: "fleet",
      ctaLabel: "Go to Vehicles",
      ctaAction: "navigate",
      isAvailable: (ctx) => ctx.vehicles_count > 0 && ctx.parts_count > 0,
      isComplete: (ctx) => ctx.vehicles_with_inventory_count > 0,
    },
  ],
};
